import styles from './JobLocation.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { DownRightArrowIcon } from 'seek-style-guide/react';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import QualifiedLink from 'QualifiedLink/QualifiedLink';
import { jobLocationClicked, jobAreaClicked, jobSuburbClicked } from 'store/search/search';

const mapDispatchToProps = dispatch => ({
  onLocationClick: () => dispatch(jobLocationClicked()),
  onAreaClick: () => dispatch(jobAreaClicked()),
  onSuburbClick: () => dispatch(jobSuburbClicked())
});

@connect(null, mapDispatchToProps)
export default class JobLocation extends Component {

  static propTypes = {
    onLocationClick: PropTypes.func.isRequired,
    onAreaClick: PropTypes.func.isRequired,
    onSuburbClick: PropTypes.func.isRequired,
    // We should never have both location and suburb
    location: PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string,
      params: PropTypes.object
    }),
    area: PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string,
      params: PropTypes.object
    }),
    suburb: PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string,
      params: PropTypes.object
    })
  };

  renderLocationPartLink({ part, clickHandler, dataAutomation, showIcon = false }) {
    const { name, title, params } = part;

    return (
      <QualifiedLink
        className={styles.link}
        path="/jobs"
        params={params}
        onClick={clickHandler}
        scrollToTop={true}
        title={title}
        aria-label={title}
        data-automation={dataAutomation}>
        {
          showIcon &&
            <DownRightArrowIcon
              className={styles.downRightArrowContainer}
              svgClassName={styles.downRightArrowSvg}
            />
        }
        {name}
      </QualifiedLink>
    );
  }

  render() {
    const {
      onLocationClick, onAreaClick, onSuburbClick,
      location, area, suburb
    } = this.props;

    return (
      <p className={styles.root}>
        <ScreenReaderOnly>Location: </ScreenReaderOnly>
        {
          location &&
            this.renderLocationPartLink({
              part: location,
              clickHandler: onLocationClick,
              dataAutomation: 'jobLocation'
            })
        }
        {
          area &&
            this.renderLocationPartLink({
              part: area,
              clickHandler: onAreaClick,
              dataAutomation: 'jobArea',
              showIcon: true
            })
        }
        {
          suburb &&
            this.renderLocationPartLink({
              part: suburb,
              clickHandler: onSuburbClick,
              dataAutomation: 'jobSuburb'
            })
        }
      </p>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SearchResultList/components/JobItem/components/JobLocation/JobLocation.js
 **/